// Shared Framer Motion animation variants
// IMPORTANT: opacity uses 0.99 (not 0) to prevent scroll rendering bugs

export const fadeInUp = {
  initial: { opacity: 0.99, y: 20 },
  animate: { opacity: 1, y: 0 }
};

export const fadeInUpSmall = {
  initial: { opacity: 0.99, y: 8 },
  animate: { opacity: 1, y: 0 }
};

export const fadeInUpTiny = {
  initial: { opacity: 0.99, y: 10 },
  animate: { opacity: 1, y: 0 }
};

export const fadeIn = {
  initial: { opacity: 0.99 },
  animate: { opacity: 1 }
};

export const fadeInLeft = {
  initial: { opacity: 0.99, x: -20 },
  animate: { opacity: 1, x: 0 }
};

export const fadeInLeftSmall = {
  initial: { opacity: 0.99, x: -8 },
  animate: { opacity: 1, x: 0 }
};

export const fadeInRightSmall = {
  initial: { opacity: 0.99, x: 8 },
  animate: { opacity: 1, x: 0 }
};

export const fadeInScale = {
  initial: { opacity: 0.99, scale: 0.9 },
  animate: { opacity: 1, scale: 1 }
};

export const spinForever = {
  animate: { rotate: 360 },
  transition: { duration: 2, repeat: Infinity, ease: "linear" }
};

// Common transition delays (memoized)
export const delay01 = { delay: 0.1 };
export const delay02 = { delay: 0.2 };
export const delay03 = { delay: 0.3 };
export const delay04 = { delay: 0.4 };
export const delay05 = { delay: 0.5 };
